import React, { SyntheticEvent, useState } from 'react';

import { Spinner } from 'components/Spinner';
import { useAuth } from 'contexts/AuthContext';
import { ConfirmationInputForm, PhoneInputForm } from './components/InputForms';
import {
  ConfirmationResult,
  getAuth,
  signInWithPhoneNumber
} from 'firebase/auth';

import './style.css';


const auth = getAuth();
export const LoginPage = () => {
  const [confirmation, setConfirmation] = useState<ConfirmationResult>();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [verificationCode, setVerificationCode] = useState<string>('');
  const [verificationError, setVerificationError] = useState(false);
  const [sendVerificationError, setSendVerificationError] = useState(false);

  const authContext = useAuth();

  const sendVerificationText = async () => {
    if (authContext.recaptchaVerifier) {
      try {
        const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, authContext.recaptchaVerifier);
        setConfirmation(confirmationResult);
      } catch (e) {
        authContext.recaptchaVerifier.render().then(function(widgetId) {
          window.grecaptcha.reset(widgetId);
        });
        setSendVerificationError(true);
      }
    } else {
      // This will only happen if there is an initial issue with creating the recaptcha object.
      // The recaptchaVerifier is instantiated on the initial load of the auth context.
      setSendVerificationError(true);
    }
  };

  const confirmVerification = async () => {
    try {
      await confirmation?.confirm(verificationCode);
      const recaptchaContainer = document.getElementById('recaptcha-container');
      if (recaptchaContainer) {
        recaptchaContainer.style.display = 'None';
      }
      authContext.recaptchaVerifier?.render();
    } catch (e) {
      setVerificationError(true);
    }
  };

  const handlePhoneSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    await sendVerificationText();
  };

  const handleVerifySubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    await confirmVerification();
  };

  if (authContext.loading) {
    return (
      <div className='login-container'>
        <Spinner />
      </div>
    );
  }

  return (
    <div className='login-container'>
      {!confirmation ? (
        <PhoneInputForm
          handleSubmit={handlePhoneSubmit}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          sendVerificationError={sendVerificationError}
        />
      ) : (
        <ConfirmationInputForm
          handleSubmit={handleVerifySubmit}
          handleResendCode={sendVerificationText}
          verificationCode={verificationCode}
          setVerificationCode={setVerificationCode}
          verificationError={verificationError}
        />
      )}
    </div>
  );
};
